/**
 * Forgot Password Controller
 */
(function () {

	angular.module('app.forgot')
		.controller('ForgotController', ForgotController);

	ForgotController.$inject = ['authentication', 'authenticationSettings','$location'];
	function ForgotController(authentication, authenticationSettings, $location) {
		// setup model data
		var vm = this;
		vm.emailAddress = '';
		vm.securityQuestion = '';
		vm.securityAnswer = '';
		vm.gettingQuestion = false;
		vm.sendingEmail = false;
		vm.checkEmail = false;

		// setup model functions
		vm.getSecurityQuestion = getSecurityQuestion;
		vm.forgotPassword = forgotPassword;
		vm.logoUrl = authenticationSettings.dynamicContentUrl + '/1234/x/images/solera-autopoint_logo2019.svg';

		function getSecurityQuestion() {
			vm.gettingQuestion = true;
			authentication.getSecurityQuestion({ username: vm.emailAddress }).then(function (response) {
				vm.errorMessage = null;
				vm.securityQuestion = response;
				vm.gettingQuestion = false;
			}, function (err) {
				vm.errorMessage = 'Email Address entered is not associated with an AutoPoint account. Please try a different email address or ask your dealership Administrator to look up your email address.';
				vm.gettingQuestion = false;
			});
		}

		function forgotPassword() {
			vm.sendingEmail = true;
			authentication.forgotPassword({ username: vm.emailAddress, answer: vm.securityAnswer }).then(function (response) {
				vm.errorMessage = null;
				vm.sendingEmail = false;
				vm.checkEmail = true;
			}, function (err) {
				vm.errorMessage = 'Invalid email address. Please try again.';
				vm.sendingEmail = false;
			});
		}

		function setBackgroundImage() {
			var host = $location.$$host;
			if (host.indexOf('mercedes') > -1) {
				$("#forgot-view").addClass('dsd-background');
			} else {
				var imgAr = [
					'/1234/x/images/sso-backgrounds/sso-back1.jpg',
					'/1234/x/images/sso-backgrounds/sso-back2.jpg',
					'/1234/x/images/sso-backgrounds/sso-back3.jpg',
					'/1234/x/images/sso-backgrounds/sso-back4.jpg',
					'/1234/x/images/sso-backgrounds/sso-back5.jpg',
					'/1234/x/images/sso-backgrounds/sso-back6.jpg',
					'/1234/x/images/sso-backgrounds/sso-back7.jpg',
					'/1234/x/images/sso-backgrounds/sso-back8.jpg',
					'/1234/x/images/sso-backgrounds/sso-back9.jpg',
					'/1234/x/images/sso-backgrounds/sso-back10.jpg',
					'/1234/x/images/sso-backgrounds/sso-back11.jpg',
					'/1234/x/images/sso-backgrounds/sso-back12.jpg'
				];
				
				var num = Math.floor(Math.random() * imgAr.length);
				var img = imgAr[num];
				$("#forgot-view").css('background-image', "url(" + authenticationSettings.dynamicContentUrl + img + ")");
			}
		}
		setBackgroundImage();

	}
})();